'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'dice-d20';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f6cf';
var svgPathData = 'M228.2-10.2c17.6-8.5 38.1-8.5 55.7 0l3.7 2 192 108.8c18.8 10.7 30.8 30 32.3 51.4l.2 4.3 0 215.5c0 21.6-10.9 41.7-28.8 53.4l-3.7 2.2-192 108.8c-19.6 11.1-43.6 11.1-63.1 0L32.4 427.4C12.4 416.1 0 394.8 0 371.8l0-215.5 .2-4.3c1.4-21.4 13.5-40.7 32.3-51.4l192-108.8 3.7-2zm35.9 443l0 95.1c3.4-.6 6.8-1.5 10-2.8l5.6-2.8 192-108.8c1.9-1.1 3.7-2.3 5.4-3.6L264 432.8zM35 410l5.4 3.5 192 108.8c4.9 2.8 10.3 4.6 15.7 5.5l0-95.1-213.1-22.8 .1 .1zm-4.6-16.7L241.9 416 135.6 216.3 30.3 393.4zM270.2 416L481.7 393.4 376.4 216.3 270.2 416zM256 408.6L362.7 208 149.3 208 256 408.6zM19.6 138.3c-2.3 5.6-3.6 11.7-3.6 18l0 215.5c0 4 .6 8 1.5 11.8L125.1 202.7 19.6 138.3zm367.4 64.4L494.5 383.5c1-3.8 1.5-7.8 1.5-11.8l0-215.5c0-6.3-1.2-12.4-3.5-18L386.9 202.7zM149.9 192L362.2 192 256 7.5 149.9 192zM240.7 2c-2.9 1-5.7 2.2-8.4 3.7L40.3 114.5 35 118c-2.6 2-4.9 4.2-7 6.6L133.2 188.9 240.7 2zM378.9 188.9L484 124.7c-3.5-4-7.6-7.5-12.3-10.2L279.7 5.7 274 2.9c-.9-.4-1.8-.6-2.7-.9L378.9 188.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiceD20 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;